const UserProfileKeys = {
  StatusNotification: {
    DRIVER_NOTIFICATION_DEFAULT_CBP_MESSAGE: "statusNotification.driverNotificationDefaultCbpMessage",
    DRIVER_NOTIFICATION_DEFAULT_CBSA_MESSAGE: "statusNotification.driverNotificationDefaultCbsaMessage"
  }
}

export default UserProfileKeys
